"use client";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from "@cmp-src/primitives/collapsible";
import { parseISO } from "date-fns";
import Link from "next/link";
import React, { useMemo, useState } from "react";
import { IOfficesSchedulesIndexed } from "@gettactic/api";
import { Alert } from "@/ui/index";
import { ReservationCardList } from "@/features/reservation/components/ReservationCard/ReservationCardList";
import { ReservationCardListDateTitle } from "@/features/reservation/components/ReservationCard/ReservationCardListDateTitle";
import { NotReservations } from "@/features/dashboard/components/reservations/NoReservations";
import { ReservationProps } from "../Reservations";

type Props = {
  schedulePendingData: IOfficesSchedulesIndexed | null;
  hasPending: boolean;
  embedded?: boolean;
  onShowingAnotherModal: ReservationProps["onShowingAnotherModal"];
};

function DateCollapsible({
  date,
  schedulePendingData,
  embedded,
  onShowingAnotherModal
}: {
  date: string;
  schedulePendingData: IOfficesSchedulesIndexed;
  embedded: boolean;
  onShowingAnotherModal: ReservationProps["onShowingAnotherModal"];
}) {
  const [open, setOpen] = useState(true);

  return (
    <div className="ml-1 mr-1">
      <Collapsible open={open} onOpenChange={setOpen}>
        <CollapsibleTrigger>
          <ReservationCardListDateTitle open={open} date={parseISO(date)} />
        </CollapsibleTrigger>
        <CollapsibleContent>
          <ReservationCardList
            listType="admin-pending"
            schedules={schedulePendingData.dates[date]}
            embedded={embedded}
            onShowingAnotherModal={onShowingAnotherModal}
          />
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}

export function TabPending({
  schedulePendingData,
  hasPending,
  embedded = false,
  onShowingAnotherModal
}: Props) {
  const dates = useMemo(() => {
    const dates = Object.keys(schedulePendingData?.dates ?? {});
    dates.sort();
    return dates;
  }, [schedulePendingData?.dates]);
  return (
    <>
      <Alert
        variant="tacticAlert"
        canDismiss={false}
        alertTitle=""
        alertMessage=""
        className="mt-2 px-4 py-2"
      >
        <p className="-mt-2 text-base">
          To manage reservations, please use the{" "}
          <Link href={`/admin`}>
            <a className="cursor-pointer text-primary underline">
              new admin dashboard.
            </a>
          </Link>
        </p>
      </Alert>
      {hasPending ? (
        <>
          {schedulePendingData &&
            dates.map((date) => (
              <DateCollapsible
                key={date}
                date={date}
                schedulePendingData={schedulePendingData}
                embedded={embedded}
                onShowingAnotherModal={onShowingAnotherModal}
              />
            ))}
        </>
      ) : (
        <NotReservations />
      )}
    </>
  );
}
